import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cached = null;
const subs = new Set();

export const loadGrowth = () => api.get("/growth/me").then(({ data }) => { cached = data; subs.forEach((f) => f(data)); return data; });

export function useGrowth() {
  const [data, setData] = useState(cached);
  useEffect(() => {
    subs.add(setData);
    loadGrowth().catch(() => {});
    return () => subs.delete(setData);
  }, []);
  return data;
}

export const inviteMsg = "Komm in die itzPlay Community! Posten, spielen, Punkte sammeln & echte Prämien bekommen 💖";
